// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';

// Internal Dependencies
import TrailInfo from './info';
import Boundaries from './boundaries';
import Reviews from './reviews';
import Posts from './posts';
import PrivateRouteAdmin from '../../../routing/PrivateRoute';

const TrailRouter = ({ match }) => (
  <Switch>
    <PrivateRouteAdmin exact path={`${match.path}`} component={TrailInfo} />
    <PrivateRouteAdmin exact path={`${match.path}/posts`} component={Posts} />
    <PrivateRouteAdmin exact path={`${match.path}/reviews`} component={Reviews} />
    <PrivateRouteAdmin exact path={`${match.path}/boundaries`} component={Boundaries} />
  </Switch>
);

TrailRouter.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

export default TrailRouter;
